import Seo from '@/components/Seo'
import SiteLayout from '@/components/SiteLayout'

export default function PrivacyPage() {
  return (
    <SiteLayout>
      <Seo
        title="Privacy Policy"
        description="Privacy Policy for Tillio POS, operated by Tillio Payment LLC."
        path="/privacy"
      />
      <section className="py-16 bg-gradient-to-br from-slate-50 to-white">
        <div className="container mx-auto max-w-3xl px-6">
          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground mb-10">
            Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <div className="space-y-8 text-base leading-relaxed">
            <p className="text-muted-foreground">
              Tillio Payment LLC (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) respects your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard information when you use Tillio POS (&quot;Service&quot;).
            </p>

            <section>
              <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
              <p className="text-muted-foreground mb-2">
                We may collect organization account details (name, email, hashed password), staff user information (name, role, PIN), and business data such as menus, orders, tables, settings, and images. Payment card data is processed by Stripe; we do not store full card numbers. We also collect technical data such as device info, IP address, and usage logs.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. How We Use Information</h2>
              <p className="text-muted-foreground">
                We use information to provide and improve the Service, process transactions, authenticate users, send service communications, monitor usage, prevent abuse, and comply with legal obligations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. How We Share Information</h2>
              <p className="text-muted-foreground">
                We do not sell personal information. We share data with service providers such as Stripe (payments), cloud storage, and hosting providers; when required by law; or in connection with a business transfer.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Data Security &amp; Retention</h2>
              <p className="text-muted-foreground">
                We use encryption, hashing, access controls, and secure storage. No method is 100% secure. We retain information as needed to provide the Service and meet legal requirements; upon account deletion we delete or anonymize personal data subject to those obligations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Your Rights</h2>
              <p className="text-muted-foreground">
                Depending on your location, you may have rights to access, correct, delete, or export your personal information. Contact us to exercise these rights.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Children&apos;s Privacy</h2>
              <p className="text-muted-foreground">
                The Service is not intended for individuals under 18 and is intended for use in the United States only.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Contact</h2>
              <p className="text-muted-foreground">
                Email: services@tilliopayment.com<br />
                Address: 1 E Erie St, Suite 525-2920, Chicago, IL 60626
              </p>
            </section>
          </div>
        </div>
      </section>
    </SiteLayout>
  )
}
